import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ---------------------------------------------------------------------------
// Timeline — vertical stem + colored dot nodes
// ---------------------------------------------------------------------------
const DEFAULT_STEM_COLOR = 'rgba(34,197,94,0.2)';
const DEFAULT_DOT_COLOR = '#22c55e';
export function Timeline({ stemColor = DEFAULT_STEM_COLOR, className = '', emptyContent, children, }) {
    // Check if children is empty
    const hasChildren = children !== null && children !== undefined && children !== false;
    if (!hasChildren && emptyContent) {
        return _jsx("div", { className: className, children: emptyContent });
    }
    return (_jsxs("div", { className: `relative ${className}`, children: [_jsx("div", { className: "absolute left-[9px] top-0 bottom-0 w-[2px] rounded-full pointer-events-none", style: {
                    background: `linear-gradient(to bottom, transparent 0%, ${stemColor} 6%, ${stemColor} 94%, transparent 100%)`,
                } }), _jsx("div", { className: "flex flex-col", children: children })] }));
}
export function TimelineItem({ dot, className = '', children, }) {
    const dotColor = dot?.color ?? DEFAULT_DOT_COLOR;
    const muted = dot?.muted ?? false;
    const dotStyle = {
        backgroundColor: dotColor,
        borderColor: 'rgba(0,0,0,0.35)',
        boxShadow: `0 0 6px ${dotColor}30`,
        opacity: muted ? 0.3 : 1,
    };
    return (_jsxs("div", { className: `flex items-stretch ${className}`, children: [_jsx("div", { className: "w-5 shrink-0 flex justify-center relative", children: _jsx("div", { className: "absolute top-[14px] w-[10px] h-[10px] rounded-full border-2", style: dotStyle }) }), _jsx("div", { className: "flex-1 min-w-0", children: children })] }));
}
export function TimelineSeparator({ label, className = '', children, }) {
    return (_jsxs("div", { className: `flex items-center gap-2 pl-5 pr-1 py-2 my-1 ${className}`, children: [_jsx("div", { className: "flex-1 h-px bg-border-default" }), label && !children && (_jsx("span", { className: "text-[10px] text-fg-muted hover:text-fg-primary bg-transparent border border-border-default rounded-full px-2.5 py-0.5 transition-colors", children: label })), children, _jsx("div", { className: "flex-1 h-px bg-border-default" })] }));
}
//# sourceMappingURL=Timeline.js.map